<div class="content">

  <!-- since last login-->
  <div class="card news">
    <ul class="p-0 m-0 news" style="width: 100%">
      <a class="click" (click)="loadSinceLastVisit()">
        <li class="mb-2">
          <span style="color: #4bb4e6">
            {{ sinceLastLogin }}
          </span>
          {{ 'pages.updates.signal.sinceLastVisitPost' | translate }}
        </li>
      </a>
    </ul>
  </div>
  
  <div class="pb-3">
      <div class="card">
        <div class="card-body">
          <div class="card-title d-flex justify-content-end">
            <h6>
              <!--advanced search -->
              <div class="form-check form-switch custom-switch right me-3" style="float:left" data-toggle="tooltip"
                data-placement="top" title="{{ 'pages.worldwatch.enableAdvSrchDesc' | translate }}">
                <input class="form-check-input" type="checkbox" role="switch" id="advanceSearch" [(ngModel)]="advSearch">
                <label class="custom-control-label" for="advanceSearch">{{ 'pages.generic.advancedSearch' | translate
                  }} </label>
              </div>
              <!-- saved search -->
              <div class="form-check form-switch custom-switch right" style="float:left" data-toggle="tooltip"
                data-placement="top" title="{{ 'pages.worldwatch.enableSavedSearchDesc' | translate }}">
                <input class="form-check-input" type="checkbox" role="switch" id="hideSaveSearch" [(ngModel)]="hideSaveSearch">
                <label class="custom-control-label" for="hideSaveSearch">{{ 'pages.generic.savedSearches' | translate
                  }}</label>
              </div>
            </h6>
          </div>
          <form>
            <!--simple search -->
            <div class="row">
  
              <!-- reference -->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top"
                title="{{ 'pages.worldwatch.searchSignalDesc' | translate }}">
                <label for="reference">{{ 'pages.updates.signal.fieldTitles.reference' | translate }} </label>
                <input type="text" class="form-control" name="reference" aria-describedby="reference" placeholder="SIG-"
                  [(ngModel)]="reference">
              </div>
  
              <!-- search -->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top"
                title="{{ 'pages.worldwatch.signalRefSearchDesc' | translate }}">
                <label for="query">{{ 'pages.generic.search' | translate }}</label>
                <input type="text" class="form-control" name="query" aria-describedby="query"
                  [placeholder]="'pages.generic.Keywords' | translate" [(ngModel)]="query">
              </div>
  
              <!-- urgency -->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                <label for="urgency">{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}</label>
                <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="urgenciesData"
                  [(ngModel)]="selectedUrgencies" name="typeFilter">
                </ng-multiselect-dropdown>
              </div>
            </div>
  
            <!-- advanced search -->
            <div [ngbCollapse]="!advSearch" id="advSearch">
              <div class="row">
  
                <!-- category -->
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                  <label for="category">{{ 'pages.updates.signal.fieldTitles.category' | translate }}</label>
                  <select class="form-select" name="category" aria-describedby="category" [(ngModel)]="category">
                    <option></option>
                    <option>{{ 'pages.worldwatch.advisory' | translate }}</option>
                    <option>{{ 'pages.worldwatch.announcement' | translate }}</option>
                    <option>{{ 'pages.worldwatch.breach' | translate }}</option>
                    <option>{{ 'pages.worldwatch.breakingStory' | translate }}</option>
                    <option>{{ 'pages.worldwatch.news' | translate }}</option>
                    <option>{{ 'pages.worldwatch.threat' | translate }}</option>
                    <option>{{ 'pages.worldwatch.update' | translate }}</option>
                    <option>{{ 'pages.worldwatch.vulnerability' | translate }}</option>
                  </select>
                </div>
  
                <!-- ioc -->
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3">
                  <label for="ioc">{{ 'pages.updates.signal.fieldTitles.ioc' | translate }}</label>
                  <input type="text" class="form-control" name="ioc" aria-describedby="ioc" placeholder="IOC"
                    [(ngModel)]="iocQuery">
                </div>
              </div>
  
              <div class="row">
                <!-- published from to -->
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-3" data-toggle="tooltip" data-placement="top"
                  title="{{ 'pages.worldwatch.dateRangeSignalSearch' | translate }}">
                  <label for="publishDate">{{ 'pages.updates.signal.fieldTitles.publishedFromTo' | translate
                    }}</label>
                  <app-help message="{{ 'pages.generic.dateRangeHelpDesc' | translate }}"></app-help>
                  <div class="row">
                    <div class="col-6" style="padding-right: 0.5rem;">
                      <input type="date" class="form-control" name="publishFrom" aria-describedby="publishFrom"
                        [(ngModel)]="publishFrom" (change)="validateDateRange()"
                        [ngClass]="{'is-invalid': !validDateRanges}">
                    </div>
                    <div class="col-6" style="padding-left:0.5">
                      <input type="date" class="form-control" name="publishTo" aria-describedby="publishTo"
                        [(ngModel)]="publishTo" (change)="validateDateRange()"
                        [ngClass]="{'is-invalid': !validDateRanges}">
                    </div>
                  </div>
                </div>
                <!-- sort -->
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-6 mb-3">
                  <label for="sort">{{ 'pages.generic.sort' | translate }}</label>
                  <select class="form-select" style="float:left;" name="sort" aria-describedby="sort" [(ngModel)]="sort">
                    <option></option>
                    <option value="date">{{ 'pages.updates.signal.fieldTitles.lastUpdate' | translate }}</option>
                    <option value="summary">{{ 'pages.updates.signal.fieldTitles.summary' | translate }}
                    </option>
                    <option value="signalUrgency">{{ 'pages.updates.signal.fieldTitles.urgency' | translate }}
                    </option>
                    <option value="mainCategory">{{ 'pages.updates.signal.fieldTitles.category' | translate }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-xs-6 mb-3" style="padding-left: 0;">
                  <label for="sort">{{ 'pages.generic.orderBy' | translate }}</label>
                  <select class="form-select" name="sortOrder" aria-describedby="sortOrder" [(ngModel)]="sortOrder">
                    <option></option>
                    <option value="-1">DESC</option>
                    <option value="1">ASC</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="ms-2 me-1">
              <button class="btn btn-primary" (click)="search()" [disabled]="!validDateRanges">{{ 'pages.generic.filter' |
                translate }}</button>
              <button class="btn btn-primary" (click)="reset()">{{ 'pages.generic.reset' | translate }}</button>
              <button class="btn btn-primary" (click)="openExportModal()" [disabled]="!validDateRanges">
                {{ 'buttons.action.generateReport' | translate }}
              </button>
              <button class="btn btn-primary save-search" (click)="openSearchModal()" [disabled]="!searched"
                data-toggle="tooltip" data-placement="top" title="{{ 'pages.worldwatch.saveSearchDesc' | translate }}">
                {{ 'pages.generic.saveSearch' | translate }}
              </button>
  
            </div>
          </form>
        </div>
      </div>
  
      <div class="card" *ngIf="savedSearches && savedSearches.length > 0" [ngbCollapse]="!hideSaveSearch"
        id="savedSearch">
        <div class="card-body save-search">
          <div class="col-8" style="margin-left: 0.75rem; margin-right: -1.25rem;">
            <!-- save search buttons -->
            <span style="float: left" *ngFor="let search of savedSearches">
              <button class="btn btn-secondary mt-1 search" title="{{search.name}}"
                [ngClass]="{'selected': selectedSearchCriteria && search.name === selectedSearchCriteria.name}"
                (click)="loadSearch(search)">
                {{ search.name }}
              </button>
            </span>
          </div>
          <div class="col-4 pe-0">
            <!-- delete search button -->
            <button class="btn btn-primary save-search mt-1" data-toggle="tooltip" data-placement="top"
              [disabled]="!selectedSearchCriteria" title="{{ 'buttons.action.deleteSearch' | translate }}"
              (click)="deleteSearch()">
              {{ 'buttons.action.deleteSearch' | translate }}
            </button>
            <!-- update search button -->
            <button class="btn btn-primary save-search mt-1" data-toggle="tooltip" data-placement="top"
              [disabled]="!selectedSearchCriteria" title="{{ 'buttons.action.updateSearch' | translate }}"
              (click)="saveSearch(true)">
              {{ 'buttons.action.updateSearch' | translate }}
            </button>
          </div>
        </div>
      </div>
  </div>
  
  <div class="rowfiller" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="loadNextValues()">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active' : page === signalsPage }"
          (click)="page = signalsPage; loadSignalsTab();">{{ 'pages.updates.signal.signals' | translate }}
          <span class="tag text-bg-primary ms-2" style="padding:0rem 0.5rem;"
            *ngIf="signalsCount > 0">{{signalsCount}}</span>
        </a>
      </li>
      <li class="nav-item" data-toggle="tooltip" data-placement="top"
        title="{{ 'pages.worldwatch.signalFlagDesc' | translate }}">
        <a class="nav-link" [ngClass]="{ 'active' : page === flaggedPage }" (click)="loadFlagged();">{{
          'pages.generic.flagged' | translate }}
          <span class="tag text-bg-primary ms-2" style="padding:0rem 0.5rem;">{{flagRefs.length}}</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active' : page === analyticsPage }"
          (click)="page = analyticsPage; loadAnalytics();">{{ 'pages.generic.analytics' | translate
          }}</a>
      </li>
    </ul>
  
    <div class="tools" *ngIf="page === signalsPage">
      <fa-icon [icon]="['fas', 'th-list']" size="2x" class="p-1 click" (click)="changeViewType('list')"></fa-icon>
      <fa-icon [icon]="['fas', 'th-large']" size="2x" class="p-1 click" (click)="changeViewType('grid')"></fa-icon>
    </div>
  
    <br /><br />
  
    <div class="row justify-content-center p-5" *ngIf="!chartDataLoaded && page === analyticsPage">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
      </div>
    </div>
  
    <div *ngIf="chartDataLoaded && page === analyticsPage">
      <h2> {{ 'pages.generic.thisMonth' | translate }} </h2>
      <div class="row p-1 status-table" *ngIf="chartDataLoaded">
        <div class="col-xl-4 col-lg-4 col-sm-12 item first-col-status">
          <h4>{{ 'pages.generic.atAGlance' | translate }}<br /><small>{{monthWord}}</small></h4>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">{{totalStats}}</h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.generic.new' | translate }}</h6>
              <a (click)="loadNew('month')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{categoryStats | statFilter : 'Breach' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.breaches' | translate }}</h6>
              <a (click)="loadCategory('month','Breach')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{urgencyStats | statFilter : 'Critical' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.critical' | translate }}</h6>
              <a (click)="loadUrgency('month','Critical')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{urgencyStats | statFilter : 'High' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.high' | translate }}</h6>
              <a (click)="loadUrgency('month','High')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row">
        <div class="col-3">
          <highcharts-chart [Highcharts]="Highcharts" [options]="catPieChartOptions" [(update)]="updateCategoryPie"
            style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-3">
          <highcharts-chart [Highcharts]="Highcharts" [options]="urgPieChartOptions" [(update)]="updateUrgencyPie"
            style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
  
        <div class="col-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="wordChartOptions" [(update)]="updateWordChart"
            style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
      </div>
    </div>
  
    <div *ngIf="annualChartDataLoaded && page === analyticsPage">
      <h2 class="pt-2"> {{ 'pages.generic.last12months' | translate }} </h2>
      <div class="row p-1 status-table" *ngIf="annualChartDataLoaded">
        <div class="col-xl-4 col-lg-4 col-sm-12 item first-col-status">
          <h4>{{ 'pages.generic.atAGlance' | translate }}<br /><small>{{ 'pages.generic.last12months' | translate }}
            </small></h4>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">{{annualTotalStats}}</h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.generic.total' | translate }}</h6>
              <a (click)="loadNew('annual')" class="btn btn-primary">{{ 'pages.generic.view' | translate }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{annualCategoryStats | statFilter : 'Breach' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.breaches' | translate }}</h6>
              <a (click)="loadCategory('annual','Breach')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{annualUrgencyStats | statFilter : 'Critical' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.critical' | translate }}</h6>
              <a (click)="loadUrgency('annual','Critical')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-xs-12">
          <div class="card">
            <div class="card-body text-center">
              <h2 class="card-title">
                <span>{{annualUrgencyStats | statFilter : 'High' }}</span>
              </h2>
              <h6 class="card-subtitle mb-2 text-muted">{{ 'pages.updates.signal.high' | translate }}</h6>
              <a (click)="loadUrgency('annual','High')" class="btn btn-primary">{{ 'pages.generic.view' | translate
                }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2" *ngIf="annualChartDataLoaded">
        <div class="col-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="catAnnualPieChartOptions"
            [(update)]="updateAnnualCategoryPie" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="urgAnnualPieChartOptions"
            [(update)]="updateAnnualUrgencyPie" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
      </div>
      <div class="row" *ngIf="annualChartDataLoaded">
        <div class="col-12" *ngIf="loadStackedBarUrgency">
  
          <highcharts-chart [Highcharts]="Highcharts" [options]="stackedBarUrgencyOptions"
            [(update)]="updateStackedBarUrgency" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-12" *ngIf="loadStackedBarCategory">
  
          <highcharts-chart [Highcharts]="Highcharts" [options]="stackedBarCategoryOptions"
            [(update)]="updateStackedBarCategory" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
        <div class="col-12 mb-4" *ngIf="loadStackedBarBreach">
  
          <highcharts-chart [Highcharts]="Highcharts" [options]="stackedBarBreachOptions"
            [(update)]="updateStackedBarBreach" style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
      </div>
    </div>
    <div class="card-body p-t-1 p-0"
      *ngIf="userPreferenceService.userPreferences.signalViewType === 'list' && (page === signalsPage || page === flaggedPage)">
      <app-signal-list [signals]="signals" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="signalsLoaded"
        (flagEmitter)="flag($event);" (sortEmitter)="sortResults($event);"></app-signal-list>
    </div>
    <div class="card-body p-t-1 p-0"
      *ngIf="userPreferenceService.userPreferences.signalViewType === 'grid' && (page === signalsPage || page === flaggedPage)">
      <app-signal-grid [signals]="signals" [flagRefs]="flagRefs" [flaggingRef]="flaggingRef" [loaded]="signalsLoaded"
        (flagEmitter)="flag($event);"></app-signal-grid>
    </div>
    <div class="row justify-content-center p-5" *ngIf="scrollLoading && (page === signalsPage || page === flaggedPage)">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ 'pages.generic.loading' | translate }}</span>
      </div>
    </div>
  </div>
</div>